import { AddAudienceWizard } from '@/components/mediaBuying/adCampaign/AddAudienceWizard'

const AddAudience = () => {
    return <AddAudienceWizard />
}

export default AddAudience
